<script lang="ts" setup>
	import TableTooltipComponent from '@/components/table/detailtable/TableTooltipComponent.vue';
	import {useFilters} from '@/store/filter.store';
	import type {Product} from 'dummen-shared';
	import {storeToRefs} from 'pinia';

	defineProps<{
		rowIndex: number;
		product: Product;
	}>();

	const {tooltips} = storeToRefs(useFilters());
</script>

<template>
	<tr :data-rowindex="rowIndex">
		<td data-column="tablenavigation-spacing"></td>
		<template v-if="product && product.fields">
			<td v-for="field in product.fields"
			    :key="field.key"
			    :class="[field.icon ? 'tooltip-icon' : '']"
			    :data-column="field.key">

				<span v-if="field.icon" :title="field.title">
					<TableTooltipComponent v-if="tooltips != null"
					                       :field="field" :tooltip="tooltips[field.key]" />
				</span>

				<div v-else class="catalog-overview-table__cell-content">
					<span :class="[field.content ? '' : 'empty-td-placeholder']"
					      v-html="field.content ? field.content : '&mdash;'">
					</span>
				</div>
			</td>
		</template>

		<td class="" data-column="tablenavigation-spacing"></td>
	</tr>
</template>

<style lang="scss" scoped>
	.tooltip-icon {
		cursor: help;
	}
</style>
